/**
 * 其知网 轮播图管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入标题"></el-input>
        <el-select size="small" v-model="formInline.module_id" style="width:140px" placeholder="请选择">
          <el-option v-for="type in moduleArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否展示：">
        <el-select size="small" v-model="formInline.is_show" style="width:140px" placeholder="请选择">
          <el-option v-for="type in isShow" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否跳转：">
        <el-select size="small" v-model="formInline.is_jump" style="width:140px" placeholder="请选择">
          <el-option v-for="type in isJump" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="module_id" align="center" label="所属模块" :formatter="moduleFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="jump_name" align="center" label="跳转文章" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="is_show" align="center" label="是否展示" :formatter="showFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="is_jump" align="center" label="是否跳转" :formatter="jumpFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="image" align="center" label="展示图" show-overflow-tooltip>
        <template slot-scope="scope">
        　  <img :src="scope.row.image" width="60" height="40" class="head_pic" v-if="scope.row.image"/>
        </template>
      </el-table-column>
      <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="upd_time" align="center" label="更新时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delCate(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-row>
            <el-form-item label="标题" prop="title">
              <el-input size="small" v-model="infoForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="展示图">
              <el-upload
                class="avatar-uploader"
                action="https://zlbb.qzhip.com/index.php/index/base/uploadFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="infoForm.image" :src="infoForm.image" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="所属模块" prop="module_id">
              <el-select size="small" v-model="infoForm.module_id" style="width:140px" placeholder="请选择" @change="moduleChange">
                <el-option v-for="type in modules" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跳转文章" prop="jump_id">
              <el-select size="small" v-model="infoForm.jump_id" style="width:140px" placeholder="请选择" @change="jumpChange">
                <el-option v-for="type in jumpArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否展示" prop="is_show">
                <el-radio v-model="infoForm.is_show" :label="1">是</el-radio>
                <el-radio v-model="infoForm.is_show" :label="2">否</el-radio>
            </el-form-item>
            <el-form-item label="是否跳转" prop="is_jump">
                <el-radio v-model="infoForm.is_jump" :label="1">是</el-radio>
                <el-radio v-model="infoForm.is_jump" :label="2">否</el-radio>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitForm('infoForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webBannerList, webEditBanner, webUrl, webDelBanner, webBannerAgent, webBannerCollege } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加轮播图',
      multipleSelection: [],
      modules: [
        { key: '专利代理', value: 1 },
        { key: '其知学院', value: 2 },
      ],
      moduleArr: [
        { key: '全部', value: 0 },
        { key: '专利代理', value: 1 },
        { key: '其知学院', value: 2 },
      ],
      isShow: [
        { key: '全部', value: 0 },
        { key: '是', value: 1 },
        { key: '否', value: 2 },
      ],
      isJump: [
        { key: '全部', value: 0 },
        { key: '是', value: 1 },
        { key: '否', value: 2 },
      ],
      jumpArr: [],
      infoForm: {
        id: '',
        title: '',
        module_id: '',
        image: '',
        is_show: '',
        is_jump: '',
        sort: '',
        jump_id: '',
        jump_name: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        name: '',
        module_id: '',
        is_show: '',
        is_jump: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      infoFormRules: {
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
        image: [{required: true, message: '请上传展示图', trigger: 'blur'}],
        imamodule_id: [{required: true, message: '请选择Banner模块', trigger: 'blur'}],
        is_show: [{required: true, message: '请选择是否显示', trigger: 'blur'}],
        is_jump: [{required: true, message: '请选择是否跳转', trigger: 'blur'}],
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webBannerList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑轮播图'
        this.infoForm.id = row.id
        this.infoForm.title = row.title
        this.infoForm.image = row.image
        this.infoForm.module_id = row.module_id
        this.infoForm.is_show = row.is_show
        this.infoForm.is_jump = row.is_jump
        this.infoForm.jump_id = row.jump_id
        this.infoForm.sort = row.sort
        this.moduleChange(row.module_id)
      } else {
        this.title = '添加轮播图'
        this.infoForm.id = ''
        this.infoForm.title = ''
        this.infoForm.image = ''
        this.infoForm.module_id = ''
        this.infoForm.is_show = ''
        this.infoForm.is_jump = ''
        this.infoForm.jump_id = ''
        this.infoForm.sort = ''
      }
    },
    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.image = res.data.url
          this.$message({
                type: 'success',
                message: '上传成功'
          })
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    // 编辑、增加页面保存方法
    submitForm(infoForm) {
      this.$refs[infoForm].validate(valid => {
        if (valid) {
          webEditBanner(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delCate(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          webDelBanner(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('分类删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 所属模块
    moduleFormat(row,column){
        if(row.module_id == 1){
            return '专利代理'
        }else if(row.module_id == 2){
            return '其知学院'
        }else{
            return '未知模块'
        }
    },
    // 是否展示
    showFormat(row,column){
        if(row.is_show == 1){
            return '是'
        }else if(row.is_show == 2){
            return '否'
        }else{
            return '未知'
        }
    },
    // 是否跳转
    jumpFormat(row,column){
        if(row.is_jump == 1){
            return '是'
        }else if(row.is_jump == 2){
            return '否'
        }else{
            return '未知'
        }
    },
    // 模块值发生改变
    moduleChange(value){
         if(value == 1){
        // 专利代理模块，查询所有代理人
          webBannerAgent()
            .then(res => {
              if (res.code == 200) {
                this.jumpArr = res.data
              }
            })
            .catch(err => {
              this.$message.error('数据获取失败')
            })
        }
        if(value == 2){
        // 其知学院模块，查询所有学院文章
        webBannerCollege()
        .then(res => {
            if(res.code == 200) {
                this.jumpArr = res.data
            }
        })
        .catch(err => {
            this.$message.error('数据获取失败')
            })
        }
    },
    // 模块值发生改变
    moduleChange:function(value){
        if(value == 1){
        // 专利代理模块，查询所有代理人
          webBannerAgent()
            .then(res => {
              if (res.code == 200) {
                this.jumpArr = res.data
              }
            })
            .catch(err => {
              this.$message.error('数据获取失败')
            })
        }
        if(value == 2){
        // 其知学院模块，查询所有学院文章
        webBannerCollege()
        .then(res => {
            if(res.code == 200) {
                this.jumpArr = res.data
            }
        })
        .catch(err => {
            this.$message.error('数据获取失败')
            })
        }

    },
    jumpChange:function(value){
        const that = this
        that.jumpArr.forEach(function(item,index){
            if(item.value == value){
                that.infoForm.jump_name = item.key
            }
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Banner.vue